export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\"/><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M17.823 8.763a1 1 0 011.497 1.32l-.083.094-6.53 6.53a1 1 0 01-1.32.083l-.094-.083-6.5-6.5a1 1 0 011.32-1.497l.094.083L12 14.585l5.823-5.822z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 24 24"
  }
};